export const getManagerApprovalString = (approval: string): string => {
  switch (approval) {
    case 'APPROVED':
      return 'Approved'

    case 'DISPUTING':
      return 'Dispute'

    case 'DENIED':
      return 'Denied'

    default:
      return 'Pending'
  }
}



// WEBPACK FOOTER //
// ./src/lib/helpers/managerApproval.ts